import axios from 'axios/index';
import React, {PureComponent} from 'react';

import {Classes, Overlay} from "@blueprintjs/core";
import toastr from 'toastr';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';
import {Link} from "@material-ui/core";

export default class PaymentMissingModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        upgradeModalTitle: this.props.title,
        upgradeModalContent: this.props.content
    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }


    componentDidMount() {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }

    componentDidUpdate = () => {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }

        if (this.state.upgradeModalTitle !== this.props.title) {
            this.setState({
                upgradeModalTitle: this.props.title
            })
        }

        if (this.state.upgradeModalContent !== this.props.content) {
            this.setState({
                upgradeModalContent: this.props.content
            })
        }
    }

    render() {
        return (
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                isOpen={this.state.overlayIsOpen}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field"
                     style={{width: this.props.width || '50%', maxWidth: this.props.maxWidth || '100%'}}>
                    <p className="modal-close-button" onClick={() => {
                        this.props.handleClose()
                    }}><i className="fas fa-times"></i></p>
                    <div className="onboarding-panel">
                        <h2 className="m-m-b text-center"> {this.state.upgradeModalTitle}
                        </h2>
                        <p className='m-lg-b'>
                            {this.state.upgradeModalContent}
                        </p>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: "center"}}>
                            <Link to='billing/payment-methods'>
                                <button className='btn-action'>Add Payment Method
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}